import MultipleCCRewardsModal from 'components/RwdBasket/RwdBasketLayout/BIBenefits/CCRewards/MultipleCCRewardsModal/MultipleCCRewardsModal';

export default MultipleCCRewardsModal;
